module.exports = __webpack_public_path__ + "7af2a9ce86e53bccd35cc5747d998b40.png";